export default "__VITE_ASSET__iBiWYNBe__"